import {
  TRYON_CLOTHING_CAPABILITY,
  VIRTUAL_TRYON_TASK_PAYLOAD_VERSION,
  type CreateVirtualTryOnTaskPayload,
  type VirtualTryOnCategory,
  type VirtualTryOnOutfitScope,
  type VirtualTryOnOutfitScopeSource,
  type VirtualTryOnQuality,
  type WorkspaceProviderOption,
} from '../../../api'
import {
  PROVIDER_SELECTION_MODE_DEFAULT,
  PROVIDER_SELECTION_MODE_EXPLICIT,
  findProviderOptionById,
  isProviderOptionSelectable,
  normalizeProviderSelectionMode,
  resolveCapabilityProviderOptionId,
  type ProviderSelectionMode,
} from './capabilityProviderSelection'
import { legacyCategoryForScope, type OutfitScope, type OutfitScopeSource } from './virtualTryOnOutfitScope'

export const DEFAULT_VIRTUAL_TRYON_QUALITY: VirtualTryOnQuality = 'balanced'
export { TRYON_CLOTHING_CAPABILITY }
export type { ProviderSelectionMode }
export {
  PROVIDER_SELECTION_MODE_DEFAULT,
  PROVIDER_SELECTION_MODE_EXPLICIT,
  normalizeProviderSelectionMode,
}

export function normalizeVirtualTryOnQuality(raw: unknown): VirtualTryOnQuality {
  return raw === 'fast' ? 'fast' : DEFAULT_VIRTUAL_TRYON_QUALITY
}

/** @deprecated Prefer resolveCapabilityProviderOptionId with selectionMode. */
export function resolveTryOnProviderOptionId(
  stored: string | null | undefined,
  options: WorkspaceProviderOption[],
  selectionMode: ProviderSelectionMode | string | null | undefined = PROVIDER_SELECTION_MODE_DEFAULT,
  serverDefaultProviderOptionId?: string | null,
): string | null {
  return resolveCapabilityProviderOptionId({
    selectionMode,
    storedProviderOptionId: stored,
    options,
    serverDefaultProviderOptionId,
  })
}

export function findTryOnProviderOption(
  options: WorkspaceProviderOption[],
  providerOptionId: string | null | undefined,
): WorkspaceProviderOption | null {
  return findProviderOptionById(options, providerOptionId)
}

export function isTryOnProviderOptionSelectable(option: WorkspaceProviderOption): boolean {
  return isProviderOptionSelectable(option)
}

export function buildVirtualTryOnSubmitPayload(args: {
  modelImageAssetId: string
  garmentAssetId: string
  outfitScope: OutfitScope | VirtualTryOnOutfitScope
  outfitScopeSource?: OutfitScopeSource | VirtualTryOnOutfitScopeSource
  /** @deprecated Prefer outfitScope — still sent for LOCAL_WORKER / older readers. */
  category?: VirtualTryOnCategory
  quality: VirtualTryOnQuality
  providerOptionId: string
  providerSelectionMode?: ProviderSelectionMode
  /** Optional supplementary instruction — forwarded only when non-empty. */
  prompt?: string | null
}): CreateVirtualTryOnTaskPayload {
  const mode = normalizeProviderSelectionMode(args.providerSelectionMode)
  const prompt = (args.prompt || '').trim()
  const scope = args.outfitScope
  const source = (args.outfitScopeSource || 'DEFAULT') as VirtualTryOnOutfitScopeSource
  const category = args.category || legacyCategoryForScope(scope as OutfitScope)
  return {
    task_payload_version: VIRTUAL_TRYON_TASK_PAYLOAD_VERSION,
    outfit_scope: scope as VirtualTryOnOutfitScope,
    outfit_scope_source: source,
    category,
    quality: args.quality,
    provider_option_id: args.providerOptionId,
    provider_selection_mode: mode,
    model_image_asset_id: args.modelImageAssetId,
    garment_reference_images: [{ asset_id: args.garmentAssetId, role: 'primary' }],
    ...(prompt ? { prompt } : {}),
  }
}
